import { useRouter } from 'next/router';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';

import { bundles } from '@data/bundles';
import { ApiClient } from '@api/client';

import { Bundle } from './Bundle';

/**
 * @param {{
 *  userId: string;
 *  userEmail: string;
 *  className?: string;
 * }} props
 *
 * @return {JSX.Element}
 */
export function Bundles({ userId, userEmail, className }) {
  const { t: tt } = useTranslation('plans');

  const router = useRouter();

  const checkoutLink = `https://ai-girlfriend.lemonsqueezy.com/checkout/buy/0a8acf44-074b-449a-8c8c-730e7dd0fef0?discount=0&checkout[email]=${encodeURIComponent(
    userEmail,
  )}`;

  const handleUpgrade = async () => {
    try {
      const resp = await ApiClient.get('/v2/user/subscriber', null, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-Clerk-User-Id': userId,
        },
      });
      const data = await resp.json();

      if (resp.ok && data.user_member) {
        await router.push(checkoutLink);
      } else {
        // User is not a member or there was an error in the request, handle accordingly
        alert('You need to have an active subscription to upgrade.');
      }
    } catch (err) {
      console.error('Error checking membership status', err);
    }
  };

  return (
    <section className={className}>
      <h2 className={clsx('text-[30px] text-center', 'mt-0 mb-[12px]')}>
        {tt('bundles.title')}
      </h2>

      <p className={clsx('text-center', 'mb-[48px]')}>
        {tt('bundles.subtitle')}
      </p>

      <ul
        className={clsx(
          'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5',
          'p-0',
          'list-none',
        )}
      >
        {bundles.map((bundle) => (
          <li key={bundle.id} className="!m-0">
            <Bundle bundle={bundle} onUpgrade={handleUpgrade} />
          </li>
        ))}
      </ul>
    </section>
  );
}
